import React from 'react';
import { Copyright } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="w-full bg-[#0F1229] border-t border-white/10 py-4 mt-auto">
      <div className="container mx-auto px-4">
        <div className="flex flex-col sm:flex-row items-center justify-center gap-2 text-sm text-text-secondary">
          <div className="flex items-center gap-2">
            <Copyright className="w-4 h-4" />
            <span>2025 - Todos los derechos reservados</span>
          </div>
          <span className="hidden sm:inline">•</span>
          <div>
            Creado por{' '}
            <a
              href="https://www.facuguardia.tech"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary font-semibold hover:text-secondary transition-colors duration-200"
            >
              Facu Guardia
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
